//转换日期格式为yyyy-mm-mm
export function getDate(str, type = '-') { //str为字符串19930812，type为分割方式‘-’或者‘/’及其他分隔字符
  if (!str) return ''
  let y = str.substring(0, 4);
  let m = str.substring(4, 6);
  let d = str.substring(6, 8);
  if (str.length == 8) {
    return y + type + m + type + d;
  } else if (str.length == 6) {
    return y + type + m;
  } else {
    return str;
  }
}
export function goUrl(url, goType) {
  //goType=0为常规跳转 ==1为新开页跳转
  ///list_product?obj=%257B%2522condition%2522%253A%255
  //let arr = []
  let listArr = [{
    toPath: '/achievements',
    right: 'TDS_search_data_research',
  },
  {
    toPath: '/dynamic',
    right: 'TDS_search_data_trend',
  },
  {
    toPath: '/expert',
    right: 'TDS_search_person',
  },
  {
    toPath: '/organization',
    right: 'TDS_search_org',
  },
  {
    toPath: '/search',
    right: 'TDS_search_all',
  }
  ]
  let detailArr = [{
    toPath: '/dynamic/detail',
    right: 'think_tank_data_trend',
  },
  {
    toPath: '/achievements/detail',
    right: 'think_tank_data_research',
  },
  {
    toPath: '/expert/detail',
    right: 'think_tank_person',
  },
  {
    toPath: '/organization/detail',
    right: 'think_tank_organization',
  },

  ]
  let urlToPath = (url + " ").match(/^\/.*?[\?/\s]/)
  if (urlToPath == null || urlToPath.length == 0 || urlToPath[0] == '') {
    return
  }
  urlToPath = urlToPath[0]
  urlToPath = urlToPath.substring(0, urlToPath.length - 1)
  let isCheck = false
  let isRight = true
  listArr.forEach((item, index) => {
    if (item.toPath == urlToPath) {
      isCheck = true;
      let obj = JSON.parse(sessionStorage.getItem('userInfo')).moduleRightInfo
      if (obj[item.right].listRight == 0) {
        let userName = sessionStorage.getItem('userName');
        if (!userName) {
          router.push('/login')
        } else {
          Message({
            message: "无权限访问，请联系图书馆管理员",
            type: "warning",
          });
        }
        isRight = false;
      }
    }
  })
  if (!isCheck) {
    detailArr.forEach((item, index) => {
      if (item.toPath == urlToPath) {
        isCheck = true;
        let obj = JSON.parse(sessionStorage.getItem('userInfo')).datasetRightInfo
        let userName = sessionStorage.getItem('userName');
        // console.log(userName)
        if (obj[item.right].detailRight == 0) {
          if (!userName) {
            router.push("/login")
          } else {

            Message({
              message: "无权限访问，请联系图书馆管理员",
              type: "warning",
            });
          }
          isRight = false;
        }
      }
    })
  }
  if (!isRight) {
    return
  }
  if (goType == 0) {
    router.push(url);
  } else {
    window.open(url, "_blank");
  }

}